'use strict';

angular.module('ClinicApp').directive('appointmentAutoReconTimeSelector', function() {
  return {
    templateUrl: '/views/directives/_appointment-auto-recon-time-selector.html',
    require: 'ngModel',
    scope: {
      defaultTime: '=',
    },
    link: function($scope, _el, _attrs, ctrl) {
      $scope.ngModelCtrl = ctrl;

      $scope.hourOptions = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
      $scope.minuteOptions = ['00', '05', '10', '15', '20', '25', '30', '35', '40', '45', '50', '55'];
      $scope.intervalOptions = ['AM', 'PM'];

      $scope.userSelected = $scope.userSelected || {};
      $scope.userSelected.date = $scope.defaultTime.format('D MMMM, YYYY');
      $scope.userSelected.hour = $scope.defaultTime.format('hh');
      $scope.userSelected.minute = $scope.defaultTime.format('mm');
      $scope.userSelected.interval = $scope.defaultTime.format('A');

      function update() {
        var params = _.pick($scope.userSelected, ['date', 'hour', 'minute', 'interval']);
        if (params.date && params.hour && params.minute && params.interval) {
          ctrl.$setViewValue(moment.utc(params.date + ' ' + params.hour + ':' + params.minute + ' ' + params.interval, 'D MMMM, YYYY hh:mm A' + 'Z'));
        } else {
          ctrl.$setViewValue(null);
        }
      }

      $scope.$watch('userSelected.date', update);
      $scope.$watch('userSelected.hour', update);
      $scope.$watch('userSelected.minute', update);
      $scope.$watch('userSelected.interval', update);
    },
  };
});
